import CompanyPendingActionTypeEnum from "@/constants/enums/CompanyPendingActionTypeEnum";
import { AdminCompanyListItem, CompanyPendingActionType } from "@/types";

type WithPendingActions = Pick<AdminCompanyListItem, "pendingActions">;

export type CompanyDecisionKind = "registered" | "invited";

const OPEN_CHANGE_TYPES: CompanyPendingActionType[] = [
  CompanyPendingActionTypeEnum.CREDIT_REQUEST,
  CompanyPendingActionTypeEnum.COMPANY_INVITED,
  CompanyPendingActionTypeEnum.COMPANY_REGISTERED,
];

export const hasOpenPendingAction = (company: WithPendingActions | null | undefined, type: CompanyPendingActionType) =>
  !!company?.pendingActions?.some((action) => action.type === type && action.status === "OPEN");

/** Companies with something for a Reviver admin to act on; they are pinned and highlighted in the list. */
export const hasOpenChange = (company: AdminCompanyListItem) =>
  !!company.hasPendingAction ||
  !!company.partialCompanyId ||
  OPEN_CHANGE_TYPES.some((type) => hasOpenPendingAction(company, type));

export const isAwaitingRegistrationApproval = (company: WithPendingActions | null | undefined) =>
  hasOpenPendingAction(company, CompanyPendingActionTypeEnum.COMPANY_REGISTERED);

/** Which approve/reject buttons the company drawer shows; null means there is nothing to decide. */
export const getDecisionKind = (company: WithPendingActions | null | undefined): CompanyDecisionKind | null => {
  if (isAwaitingRegistrationApproval(company)) return "registered";
  if (hasOpenPendingAction(company, CompanyPendingActionTypeEnum.COMPANY_INVITED)) return "invited";
  return null;
};

/**
 * The backend reports a self-registered company as PENDING while it awaits approval, which the list would show as a
 * new application; after the decision its REJECTED or ACTIVE status is shown as is.
 */
export const getAdminStatusKey = (company: AdminCompanyListItem) =>
  isAwaitingRegistrationApproval(company) ? "AWAITING_APPROVAL" : company.status;
